export default {
  entities: {
    category: {
      select: {
        label: 'Категория',
      },
    },
  },
};
